import PersonAvatar from '@/components/PersonAvatar'
import Link from 'next/link'

const VacancyContent = ({ pageType, data }) => {
    return (
        <>
            {pageType === 'vacancy' && (
                <div className='vacancy__contacts'>
                    <p className='vacancy__contacts-text'>По всем вопросам можно обращаться:</p>
                    <ul className='vacancy__contacts-list'>
                        <li className='vacancy__contacts-item'>
                            <Link href=''>+7 (47474) 21-13-2</Link>
                        </li>
                        <li className='vacancy__contacts-item'>
                            <Link href=''>+7 905 855-45-18</Link>
                        </li>
                        <li className='vacancy__contacts-item'>
                            <Link href=''>hr@megamix.ru</Link>
                        </li>
                    </ul>
                </div>
            )}
            {pageType !== 'vacancy' && (
                <div className='news-details__authors'>
                    {data &&
                        data.responsible_id?.map(person => (
                            <PersonAvatar
                                key={person.id}
                                image={`${process.env.NEXT_PUBLIC_API_ENDPOINT_IMAGES_PROD}/${person.photo}`}
                                bg='linear-gradient(#3156A8, #2D3079)'
                                info={person}
                            />
                        ))}
                </div>
            )}
        </>
    )
}

export default VacancyContent
